//Generated File 
export default class SimpleEntities{
	static readonly ApprovalCase = `ApprovalCase`;
	static readonly CostInTrans = `CostInTrans`;
	static readonly CostOutTrans = `CostOutTrans`;
	static readonly FifoCostTrans = `FifoCostTrans`;
	static readonly LedgerTrans = `LedgerTrans`;
	static readonly QtySemiTrans = `QtySemiTrans`;
	static readonly QtyTrans = `QtyTrans`;
	static readonly ReservationTrans = `ReservationTrans`;
}
